class PanelStore extends FluxBaseStore
  @storeName = 'PanelStore'

  @handlers =
    TOGGLE_PANEL_COLLAPSE:  'toggleCollapsed'
    TOGGLE_PANEL_SHOW_MORE: 'toggleShowMore'
    CLEAR_ALL:              'resetShowMoreToDefault'
    RECEIVE_PANELS:         'load'
    CLEAR_SIDEBAR:          'clear'

  initialize: ->
    @_panels = {}

  clear: ->
    @initialize()
    @emitChange()

  load: (rawPanels) ->
    @_panels = rawPanels

    for key, panel of @_panels
      panel.collapsed = true
      panel.facetContexts ?= [key]

    @emitChange()

  get: (key) ->
    @_panels[key]

  keysFilteredBy: (property, {negate} = {negate: false}) ->
    Object.keys(@_panels).filter (key) =>
      val = @get(key)[property]
      if negate then not val else val

  facetContextsFilteredBy: (property) ->
    if property is 'expanded'
      negate = true
      property = 'collapsed'

    @keysFilteredBy(property, negate: negate).reduce (memo, key) =>
      memo.concat @get(key).facetContexts
    , []

  toggleCollapsed: ({keys}) ->
    keys = [keys] unless Array.isArray keys
    for key in keys
      panel = @get key
      panel.collapsed = not panel.collapsed
    @_loadMissing = true # For Selected Facets List
    @emitChange()

  toggleShowMore: ({key}) ->
    panel = @get(key)
    panel.showMore = not panel.showMore
    @_toggleShowMoreFacetContexts(panel: panel)
    @emitChange()

  _toggleShowMoreFacetContexts: ({panel}) ->
    return unless panel.showMoreFacetContexts?
    if panel.showMore
      panel.facetContexts = panel.facetContexts.concat panel.showMoreFacetContexts
    else
      panel.facetContexts = panel.facetContexts.filter (facetContext) -> facetContext not in panel.showMoreFacetContexts

  resetShowMoreToDefault: () ->
    for key, panel of @_panels
      if panel.showMoreFacetContexts
        panel.showMore = false
        panel.facetContexts = panel.facetContexts.filter (facetContext) -> facetContext not in panel.showMoreFacetContexts

  resetPanelState: (key) ->
    panel = @_panels[key]

    if panel?.showMoreFacetContexts
      panel.showMore = false
      panel.facetContexts = panel.facetContexts.filter (facetContext) -> facetContext not in panel.showMoreFacetContexts

  # Returns 'below' or 'above' based on the position of panelId regarding targetPanelId
  position: (panelId, targetPanelId) ->
    panelKeys = Object.keys(@_panels);

    if panelKeys.indexOf(panelId) > panelKeys.indexOf(targetPanelId)
      'below'
    else
      'above';

LP.module('Searches').PanelStore = PanelStore
